"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../../api/webAApi");
var BonusWagerNoDepositCfgCtl = /** @class */ (function (_super) {
    __extends(BonusWagerNoDepositCfgCtl, _super);
    function BonusWagerNoDepositCfgCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this._errDialog = errDialog;
        return _this;
    }
    BonusWagerNoDepositCfgCtl.prototype.ResetData = function () {
        this.DATA = {
            bonus_amount_value: 0,
            bonus_wager_multiplier: 0,
            bonus_min_balance_to_activate: 0,
            is_bonus_req_min_balance_to_activate: false,
            is_bonus_has_up_to_withdraw_amount_limit: false,
            bonus_up_to_withdraw_amount_limit: 0,
            is_bonus_has_up_to_bonus_amount_limit: false,
            bonus_up_to_bonus_amount_limit: 0,
            is_bonus_has_up_to_bet_amount_limit: false,
            bonus_up_to_bet_amount_limit: 0,
            bonus_cancel_type_code: 0,
            bonus_cancel_type_title: "",
            bonus_debit_type_code: 0,
            bonus_debit_type_title: "",
            bonus_withdrawal_type_code: 0,
            bonus_withdrawal_type_title: "",
            bonus_activation_type_code: 0,
            bonus_activation_type_title: "",
            is_bonus_deposit_allowed: false,
            on_deposit_add_percent_value_on_bonus_balance: 0,
            on_deposit_add_percent_value_on_bonus_wagering: 0,
            is_auto_complete_bonus: false,
            freespin_gameset_id: 0,
            freespin_gameset_title: "",
            is_freespin_pre_selected_game: false,
            freespin_game_id: 0,
            freespin_game_title: "",
            freespin_count: 10,
            is_freespin_pre_selected_bet: false,
            freespin_bet: 0.01,
            is_freespin_pre_selected_denomination: false,
            freespin_denomination: 0.01,
            is_freespin_pre_selected_multiplier: false,
            freespin_multiplier: 1,
            is_freespin_pre_selected_lines: false,
            freespin_lines: 0,
            is_bonus_get_wager_and_amount_from_level: false,
            bonus_wager_and_amount_level_source_type_code: 0,
            bonus_wager_and_amount_level_source_type_title: "",
            is_custom_gws_zone: false,
            custom_gws_zone_id: 0,
            custom_gws_zone_title: "",
            is_override_gws_player_zone: false,
            is_active_bonus_has_expiration: false,
            bonus_expiration_action_code: 0,
            bonus_expiration_action_title: "",
            active_bonus_expiration_ttl_hours: 2050,
        };
    };
    BonusWagerNoDepositCfgCtl.prototype.LoadData = function (key, onDone) {
        var _this = this;
        webAApi_1.DetailsWagerNoDepBonusTemplateConfigGet.exec({
            bonus_template_currency_config_id: key
        }, function (resp) {
            _this.DATA.bonus_amount_value = resp.bonus_amount_value;
            _this.DATA.bonus_wager_multiplier = resp.bonus_wager_multiplier;
            _this.DATA.bonus_min_balance_to_activate = resp.bonus_min_balance_to_activate;
            _this.DATA.is_bonus_req_min_balance_to_activate = resp.is_bonus_req_min_balance_to_activate;
            _this.DATA.bonus_up_to_withdraw_amount_limit = resp.bonus_up_to_withdraw_amount_limit;
            _this.DATA.is_bonus_has_up_to_withdraw_amount_limit = resp.is_bonus_has_up_to_withdraw_amount_limit;
            _this.DATA.bonus_up_to_bonus_amount_limit = resp.bonus_up_to_bonus_amount_limit;
            _this.DATA.is_bonus_has_up_to_bonus_amount_limit = resp.is_bonus_has_up_to_bonus_amount_limit;
            _this.DATA.bonus_up_to_bet_amount_limit = resp.bonus_up_to_bet_amount_limit;
            _this.DATA.is_bonus_has_up_to_bet_amount_limit = resp.is_bonus_has_up_to_bet_amount_limit;
            _this.DATA.bonus_cancel_type_code = resp.bonus_cancel_type_code;
            _this.DATA.bonus_cancel_type_title = resp.bonus_cancel_type_title;
            _this.DATA.bonus_debit_type_code = resp.bonus_debit_type_code;
            _this.DATA.bonus_debit_type_title = resp.bonus_debit_type_title;
            _this.DATA.bonus_activation_type_code = resp.bonus_activation_type_code;
            _this.DATA.bonus_activation_type_title = resp.bonus_activation_type_title;
            _this.DATA.bonus_withdrawal_type_code = resp.bonus_withdrawal_type_code;
            _this.DATA.bonus_withdrawal_type_title = resp.bonus_withdrawal_type_title;
            _this.DATA.is_bonus_deposit_allowed = resp.is_bonus_deposit_allowed;
            _this.DATA.on_deposit_add_percent_value_on_bonus_balance = resp.on_deposit_add_percent_value_on_bonus_balance;
            _this.DATA.on_deposit_add_percent_value_on_bonus_wagering = resp.on_deposit_add_percent_value_on_bonus_wagering;
            _this.DATA.is_auto_complete_bonus = resp.is_auto_complete_bonus;
            _this.DATA.freespin_gameset_id = resp.freespin_gameset_id;
            _this.DATA.freespin_gameset_title = resp.freespin_gameset_title;
            _this.DATA.is_freespin_pre_selected_game = resp.is_freespin_pre_selected_game;
            _this.DATA.freespin_game_id = resp.freespin_game_id;
            _this.DATA.freespin_game_title = resp.freespin_game_title;
            _this.DATA.freespin_count = resp.freespin_count;
            _this.DATA.is_freespin_pre_selected_bet = resp.is_freespin_pre_selected_bet;
            _this.DATA.freespin_bet = resp.freespin_bet;
            _this.DATA.is_freespin_pre_selected_denomination = resp.is_freespin_pre_selected_denomination;
            _this.DATA.freespin_denomination = resp.freespin_denomination;
            _this.DATA.is_freespin_pre_selected_multiplier = resp.is_freespin_pre_selected_multiplier;
            _this.DATA.freespin_multiplier = resp.freespin_multiplier;
            _this.DATA.is_bonus_get_wager_and_amount_from_level = resp.is_bonus_get_wager_and_amount_from_level;
            _this.DATA.bonus_wager_and_amount_level_source_type_code = resp.bonus_wager_and_amount_level_source_type_code;
            _this.DATA.bonus_wager_and_amount_level_source_type_title = resp.bonus_wager_and_amount_level_source_type_title;
            _this.DATA.is_freespin_pre_selected_lines = resp.is_freespin_pre_selected_lines;
            _this.DATA.freespin_lines = resp.freespin_lines;
            _this.DATA.is_custom_gws_zone = resp.is_custom_gws_zone;
            _this.DATA.custom_gws_zone_id = resp.custom_gws_zone_id;
            _this.DATA.custom_gws_zone_title = resp.custom_gws_zone_title;
            _this.DATA.is_override_gws_player_zone = resp.is_override_gws_player_zone;
            _this.DATA.is_active_bonus_has_expiration = resp.is_active_bonus_has_expiration;
            _this.DATA.bonus_expiration_action_code = resp.bonus_expiration_action_code;
            _this.DATA.bonus_expiration_action_title = resp.bonus_expiration_action_title;
            _this.DATA.active_bonus_expiration_ttl_hours = resp.active_bonus_expiration_ttl_hours;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BonusWagerNoDepositCfgCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoEditWagerNoDepBonusTemplateConfig.exec({
            data: {
                bonus_template_currency_config_id: data.bonus_template_currency_config_id,
                bonus_amount_value: data.bonus_amount_value,
                bonus_min_balance_to_activate: data.bonus_min_balance_to_activate,
                is_bonus_req_min_balance_to_activate: data.is_bonus_req_min_balance_to_activate,
                bonus_wager_multiplier: data.bonus_wager_multiplier,
                bonus_up_to_withdraw_amount_limit: data.bonus_up_to_withdraw_amount_limit,
                is_bonus_has_up_to_withdraw_amount_limit: data.is_bonus_has_up_to_withdraw_amount_limit,
                bonus_up_to_bonus_amount_limit: data.bonus_up_to_bonus_amount_limit,
                is_bonus_has_up_to_bonus_amount_limit: data.is_bonus_has_up_to_bonus_amount_limit,
                bonus_up_to_bet_amount_limit: data.bonus_up_to_bet_amount_limit,
                is_bonus_has_up_to_bet_amount_limit: data.is_bonus_has_up_to_bet_amount_limit,
                bonus_cancel_type_code: data.bonus_cancel_type_code,
                bonus_debit_type_code: data.bonus_debit_type_code,
                bonus_withdrawal_type_code: data.bonus_withdrawal_type_code,
                bonus_activation_type_code: data.bonus_activation_type_code,
                is_bonus_deposit_allowed: data.is_bonus_deposit_allowed,
                on_deposit_add_percent_value_on_bonus_balance: data.on_deposit_add_percent_value_on_bonus_balance,
                on_deposit_add_percent_value_on_bonus_wagering: data.on_deposit_add_percent_value_on_bonus_wagering,
                is_auto_complete_bonus: data.is_bonus_auto_complete,
                freespin_gameset_id: data.freespin_gameset_id,
                is_freespin_pre_selected_game: data.is_freespin_pre_selected_game,
                freespin_game_id: data.freespin_game_id,
                freespin_count: data.freespin_count,
                is_freespin_pre_selected_bet: data.is_freespin_pre_selected_bet,
                freespin_bet: data.freespin_bet,
                is_freespin_pre_selected_denomination: data.is_freespin_pre_selected_denomination,
                freespin_denomination: data.freespin_denomination,
                is_freespin_pre_selected_multiplier: data.is_freespin_pre_selected_multiplier,
                freespin_multiplier: data.freespin_multiplier,
                is_bonus_get_wager_and_amount_from_level: data.is_bonus_get_wager_and_amount_from_level,
                bonus_wager_and_amount_level_source_type_code: data.bonus_wager_and_amount_level_source_type_code,
                is_freespin_pre_selected_lines: data.is_freespin_pre_selected_lines,
                freespin_lines: data.freespin_lines,
                is_custom_gws_zone: data.is_custom_gws_zone,
                custom_gws_zone_id: data.custom_gws_zone_id,
                is_override_gws_player_zone: data.is_override_gws_player_zone,
                is_active_bonus_has_expiration: data.is_active_bonus_has_expiration,
                bonus_expiration_action_code: data.bonus_expiration_action_code,
                active_bonus_expiration_ttl_hours: data.active_bonus_expiration_ttl_hours,
            }
        }, function (resp) {
            _this.DATA.bonus_amount_value = data.bonus_amount_value;
            _this.DATA.bonus_wager_multiplier = data.bonus_wager_multiplier;
            _this.DATA.bonus_min_balance_to_activate = data.bonus_min_balance_to_activate;
            _this.DATA.is_bonus_req_min_balance_to_activate = data.is_bonus_req_min_balance_to_activate;
            _this.DATA.bonus_up_to_withdraw_amount_limit = data.bonus_up_to_withdraw_amount_limit;
            _this.DATA.is_bonus_has_up_to_withdraw_amount_limit = data.is_bonus_has_up_to_withdraw_amount_limit;
            _this.DATA.bonus_up_to_bonus_amount_limit = data.bonus_up_to_bonus_amount_limit;
            _this.DATA.is_bonus_has_up_to_bonus_amount_limit = data.is_bonus_has_up_to_bonus_amount_limit;
            _this.DATA.bonus_up_to_bet_amount_limit = data.bonus_up_to_bet_amount_limit;
            _this.DATA.is_bonus_has_up_to_bet_amount_limit = data.is_bonus_has_up_to_bet_amount_limit;
            _this.DATA.bonus_cancel_type_code = data.bonus_cancel_type_code;
            _this.DATA.bonus_cancel_type_title = resp.bonus_cancel_type_title;
            _this.DATA.bonus_debit_type_code = data.bonus_debit_type_code;
            _this.DATA.bonus_debit_type_title = resp.bonus_debit_type_title;
            _this.DATA.bonus_withdrawal_type_code = data.bonus_withdrawal_type_code;
            _this.DATA.bonus_withdrawal_type_title = resp.bonus_withdrawal_type_title;
            _this.DATA.bonus_activation_type_code = data.bonus_activation_type_code;
            _this.DATA.bonus_activation_type_title = resp.bonus_activation_type_title;
            _this.DATA.is_bonus_deposit_allowed = data.is_bonus_deposit_allowed;
            _this.DATA.on_deposit_add_percent_value_on_bonus_balance = data.on_deposit_add_percent_value_on_bonus_balance;
            _this.DATA.on_deposit_add_percent_value_on_bonus_wagering = data.on_deposit_add_percent_value_on_bonus_wagering;
            _this.DATA.is_auto_complete_bonus = data.is_bonus_auto_complete;
            _this.DATA.freespin_gameset_id = data.freespin_gameset_id;
            _this.DATA.freespin_gameset_title = resp.freespin_gameset_title;
            _this.DATA.is_freespin_pre_selected_game = data.is_freespin_pre_selected_game;
            _this.DATA.freespin_game_id = data.freespin_game_id;
            _this.DATA.freespin_game_title = resp.freespin_game_title;
            _this.DATA.freespin_count = data.freespin_count;
            _this.DATA.is_freespin_pre_selected_bet = data.is_freespin_pre_selected_bet;
            _this.DATA.freespin_bet = data.freespin_bet;
            _this.DATA.is_freespin_pre_selected_denomination = data.is_freespin_pre_selected_denomination;
            _this.DATA.freespin_denomination = data.freespin_denomination;
            _this.DATA.is_freespin_pre_selected_multiplier = data.is_freespin_pre_selected_multiplier;
            _this.DATA.freespin_multiplier = data.freespin_multiplier;
            _this.DATA.is_freespin_pre_selected_lines = data.is_freespin_pre_selected_lines;
            _this.DATA.freespin_lines = data.freespin_lines;
            _this.DATA.is_bonus_get_wager_and_amount_from_level = data.is_bonus_get_wager_and_amount_from_level;
            _this.DATA.bonus_wager_and_amount_level_source_type_code = data.bonus_wager_and_amount_level_source_type_code;
            _this.DATA.bonus_wager_and_amount_level_source_type_title = resp.bonus_wager_and_amount_level_source_type_title;
            _this.DATA.is_custom_gws_zone = data.is_custom_gws_zone;
            _this.DATA.custom_gws_zone_id = data.custom_gws_zone_id;
            _this.DATA.custom_gws_zone_title = resp.custom_gws_zone_title;
            _this.DATA.is_override_gws_player_zone = data.is_override_gws_player_zone;
            _this.DATA.is_active_bonus_has_expiration = data.is_active_bonus_has_expiration;
            _this.DATA.bonus_expiration_action_code = data.bonus_expiration_action_code;
            _this.DATA.bonus_expiration_action_title = resp.bonus_expiration_action_title;
            _this.DATA.active_bonus_expiration_ttl_hours = data.active_bonus_expiration_ttl_hours;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return BonusWagerNoDepositCfgCtl;
}(BaseController_1.BaseController));
exports.BonusWagerNoDepositCfgCtl = BonusWagerNoDepositCfgCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_bonus_templates/ctl/wager_no_dep/BonusWagerNoDepositCfgCtl.ts
// module id = 879
// module chunks = 0